import { AceProjektAceProjektEnumsAceProjektStatuscode, AnfrageDisplayModel, GlobalEnumsAcePortalstatus, GlobalEnumsAceTypphase } from "@/api/model-index";
import { AnfrageContract } from "./abstractions/anfrage.contract";

export class Projekt implements AnfrageContract
{
    protected anfrage: AnfrageDisplayModel;

    public constructor(anfrage: AnfrageDisplayModel)
    {
        this.anfrage = anfrage;
    }

    /**
     * Determines whether the anfrage is a draft.
     * 
     * @returns boolean
     */
    public get isDraft(): boolean
    {
        return this.anfrage.projektStatus == AceProjektAceProjektEnumsAceProjektStatuscode.Entwurf;
    }

    /**
     * Determines whether the anfrage has been captured.
     * 
     * @returns boolean
     */
    public get isCaptured(): boolean
    {
        return this.anfrage.projektStatus == AceProjektAceProjektEnumsAceProjektStatuscode.Erfasst;
    }

    public get isInAudit(): boolean
    {
        return this.anfrage.projektStatus == AceProjektAceProjektEnumsAceProjektStatuscode.InPrufung;
    }

    public get isEndorsed(): boolean
    {
        return this.anfrage.projektStatus == AceProjektAceProjektEnumsAceProjektStatuscode.Entscheidung;
    }

    public get isRevokable(): boolean
    {
        if (! this.isAntragsphase)
            return false;

        return this.isCaptured || this.isInAudit || this.isEndorsed;
    }

    public get isAntragsphase(): boolean
    {
        return this.anfrage.phase?.typ == GlobalEnumsAceTypphase.Standard;
    }

    /**
     * Determines whether the anfrage is marked as revoked.
     * 
     * @returns boolean
     */
    public get markedAsRevoked(): boolean {
        return this.anfrage.projektStatus == <number>AceProjektAceProjektEnumsAceProjektStatuscode.Zuruckziehenbeantragt
    }

    /**
     * Marks the anfrage as revoked.
     * 
     * @returns void
     */
    public markAsRevoked(): void {
        this.anfrage.projektStatus = <number>AceProjektAceProjektEnumsAceProjektStatuscode.Zuruckziehenbeantragt
    }

    /**
     * Revokes the anfrage.
     * 
     * @returns void
     */
    public revoke(): void {
        throw new Error("Method not implemented.");
    }

    /**
     * Determines whether the anfrage is in progress.
     * 
     * @returns boolean
     */
    public get isInProgress(): boolean {
        return this.anfrage.portalStatus == GlobalEnumsAcePortalstatus.inUberarbeitung;
    }
}